export const urls = {
  GET_DNEVNIK:
    'DnevnaEvidencija/vrati_dnevne_evidenciju_za_idDok_radnog_naloga',
  GET_IZVESTAJ_SA_TERENA: 'DnevnaEvidencija/masine_dnevnik_izvestaj_sa_terena',
  GET_BAZA_ZNANJA: 'DnevnaEvidencija/masine_dnevnik_baza_znanja',
  GET_RN_ZA_ID: 'DokRNServisni/rn_servisni_pregled_sa_filterom_za_idDok',
  GET_PUSTANJE_U_RAD_ZA_ID:
    'DokRNPustanjeURad/rn_pustanje_u_rad_pregled_sa_filterom_za_id_dok',
};
